import http, { ResponseData } from './httpService'
import { loginInterface, SaTokenInfo } from '../typings/user'

export const login = async (param: loginInterface): Promise<SaTokenInfo> => {
  const { data } = await http.post<ResponseData<SaTokenInfo>>('/fe/user/center/user/login', param)
  return data.data
}
